import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Bell, Check } from "lucide-react";

export default function Notifications() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markRead = async (id) => { await api.patch(`/notifications/${id}/read`); load(); };
  return (
    <div>
      <div className="eyebrow flex items-center gap-1"><Bell size={12} /> Notifications</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>Notifications</h1>
      <div className="mt-4 space-y-2">
        {items.map((n) => (
          <div key={n.id} data-testid={`notif-${n.id}`} className={`hag-surface p-3 flex items-start gap-3 ${n.read ? "opacity-70" : ""}`}>
            <div className={`w-2 h-2 mt-2 rounded-full ${n.read ? "bg-[#7C8E9E]" : "bg-red-600"}`} />
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-sm">{n.title}</div>
              <div className="text-xs text-[#4A627A]">{n.body}</div>
              <div className="text-[10px] text-[#7C8E9E] mt-1">{new Date(n.created_at).toLocaleString()} · {n.type}</div>
            </div>
            {!n.read && (
              <button data-testid={`notif-read-${n.id}`} onClick={() => markRead(n.id)} className="text-[#4A627A] hover:text-[#1B3A5C]" title="Mark read">
                <Check size={16} />
              </button>
            )}
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-[#7C8E9E]">No notifications.</div>}
      </div>
    </div>
  );
}
